const request = (path, options = {}) =>
  fetch(process.env.REACT_APP_API_HOST + path, {
    credentials: 'include',
    ...options
  }).then(async response => {
    if (response.status === 204) {
      return ''
    } else if (!response.ok) {
      return Promise.reject(await response.json())
    }

    return response.json()
  })

export const post = (path, options = {}) =>
  request(path, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: options.payload ? JSON.stringify(options.payload) : undefined,
    ...options
  })

export const get = (path, options = {}) =>
  request(path, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    ...options
  })

export const getSSOForEmail = email =>
  get(`/sso_checks?email=${encodeURIComponent(email)}`)

export const getUriForEmail = email =>
  get(`/two_factor/uri?email=${encodeURIComponent(email)}`)

export const verifyValid2FA = (email, password) =>
  post('/two_factor/verify_valid_user', {
    payload: {
      email,
      password
    }
  })



// WEBPACK FOOTER //
// ./src/utils/api.js